import { Dispatch, SetStateAction, useMemo, useState } from 'react'

import { useParams } from 'react-router-dom'

import {
  useGetLogisticItem,
  useGetLogisticsList
} from '@/hooks/queries/use-get-logistics'
import { ILogisticItems, ILogisticsDetail } from '@/interfaces/logistics'
import { createContext } from '@/utils/create-context'

interface IEditarEncomendaContextProps {
  itemLogistica: ILogisticsDetail | undefined
  isLoadingItem: boolean
  itensLogistica: ILogisticItems | undefined
  isLoadingItens: boolean
  isFetchingItens: boolean
  setPage: Dispatch<SetStateAction<number>>
  pageSize: number
  setPageSize: Dispatch<SetStateAction<number>>
  totalPages: number
  setSearch: Dispatch<SetStateAction<string>>
  openModal: boolean
  setOpenModal: Dispatch<SetStateAction<boolean>>

}

const [useEditarEncomendaContext, EditarEncomendaProvider] =
  createContext<IEditarEncomendaContextProps>()

const EditarEncomendaContext = ({ children }: JSX.Element | any) => {
  const { id, rastreioApi } = useParams()  
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [pageSize, setPageSize] = useState<number>(10)

  const { data: itemLogistica, isLoading: isLoadingItem } = useGetLogisticItem(id, rastreioApi === 'true')
  const [openModal, setOpenModal] = useState(false)

  const {
    data: itensLogistica,
    isLoading: isLoadingItens,
    isFetching: isFetchingItens
  } = useGetLogisticsList({
    page,
    pageSize,
    groupNumber: id,
    rastreioApi: rastreioApi === 'true',
    search
  })
  
  const totalPages = Math.ceil(
    (itensLogistica?.totalItems ?? 0) / (pageSize ?? 1)
  )

  const contextValue = useMemo(
    () => ({
      itemLogistica,
      isLoadingItem,
      itensLogistica,
      isLoadingItens,
      isFetchingItens,
      setPage,
      pageSize,
      setPageSize,
      totalPages,
      setSearch,
      openModal,
      setOpenModal
    }),
    [
      itemLogistica,
      isLoadingItem,
      itensLogistica,
      isLoadingItens,
      isFetchingItens,
      setPage,
      pageSize,
      setPageSize,
      totalPages,
      setSearch,
      openModal,
      setOpenModal
    ]
  )

  return (
    <EditarEncomendaProvider value={contextValue}>
      {children}
    </EditarEncomendaProvider>
  )
}

export { EditarEncomendaContext, useEditarEncomendaContext }
